import { render, staticRenderFns } from "./FiltersPublications.vue?vue&type=template&id=0da586e8&scoped=true&"
var script = {}
import style0 from "./FiltersPublications.vue?vue&type=style&index=0&id=0da586e8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da586e8",
  null
  
)

export default component.exports